<template>
  <ankh-list :padding="0" :show-btn-group="!isPlain" v-bind="$attrs">
    <template #search-form>
      <el-form-item :label="$t('液晶名称')">
        <el-input :placeholder="$t('液晶名称')" clearable v-model="searchForm.name" />
      </el-form-item>
      <el-form-item :label="$t('协议代码')">
        <el-input :placeholder="$t('协议代码')" clearable v-model="searchForm.protocolCode" />
      </el-form-item>
      <el-form-item :label="$t('创建日期')">
        <date-time-range-picker
            :start-time.sync="searchForm.startCreateTime"
            :end-time.sync="searchForm.endCreateTime" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('查询')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #btn-group>
      <el-button size="small" type="primary" @click="handleShowFormDialog()">{{$t('新增')}}</el-button>
      <el-button size="small" type="primary" @click="$emit('export')">{{$t('导出')}}</el-button>
      <el-button size="small" type="danger" @click="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #table="{height}">
      <table-list
          :height="height"
          ref="list"
          :search-params="searchForm"
          @query="loadList"
          @selection-change="selection = $event"
          :data="tableData">
        <el-table-column type="selection" width="50" />
        <el-table-column type="index" :label="$t('序号')" width="50" />
        <el-table-column :label="$t('液晶名称')" prop="name" />
        <el-table-column :label="$t('协议代码')">
          <template v-slot="{row}">
            <div class="flex" style="column-gap: 6px" v-if="row.protocolCode">
              <el-link :underline="false" type="primary">{{ row.protocolCode || "" }}</el-link>
              <i class="el-icon-copy-document" @click="handleCopy(row)" />
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('展示内容')" prop="content" />
        <el-table-column :label="$t('创建日期')">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('备注')" prop="remark" />
        <el-table-column :label="$t('操作')" v-if="!isPlain">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link :underline="false" type="primary" @click="handleShowFormDialog(row)">{{$t('编辑')}}</el-link>
              <el-link :underline="false" type="danger" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template #other>
      <hardware-form
          :rules="rules"
          :is-edit="isEdit"
          :data="currentRow"
          @confirm="handleAddOrEditSubmit"
          :visible.sync="showDialog"
          :form-items="formConfig" />
    </template>
  </ankh-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {exeCommandCopyText} from "@/utils/common";
import {request, requestByTip} from "@/config/request";
import HardwareForm from "@/components/hardware/HardwareForm";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
import AnkhList from "@/components/list/AnkhList.vue";
import {exportExcel} from "@/utils/export";

export default {
  name: "LiquidCrystal",
  components: {AnkhList, DateTimeRangePicker, HardwareForm, TableList},
  props: {
    isPlain: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      tableData: [],
      searchForm: {},
      selection: [],
      showDialog: false,
      formConfig: [
        {label: "液晶名称", prop: "name", type: "text"},
        {label: "协议代码", prop: "protocolCode", type: "text"},
        {label: "展示内容", prop: "content", type: "text"},
        {label: "备注", prop: "remark", type: "textarea", rows: 5}
      ],
      rules: {
        name: [
          {required: true, message: this.$t('请输入液晶名称'), trigger: 'blur'},
        ],
        protocolCode: {required: true, message: this.$t('请输入协议代码'), trigger: 'change'}
      },
      isEdit: false,
      currentRow: {}
    }
  },
  methods: {
    // 导出
    handleExport() {
      const codes = this.selection.map(item => item.code);
      exportExcel(codes, this.$api.common.exportLiquidCrystal);
    },

    // 复制
    handleCopy(row) {
      const flag = exeCommandCopyText(row.protocolCode)
      this.$message({
        type: flag ? 'success' : 'error',
        message: flag ? this.$t('复制成功') : this.$t('复制失败')
      })
    },

    // 新增\编辑
    async handleAddOrEditSubmit(data) {
      try {
        const action = this.$api.liquidCrystal[this.isEdit ? 'update' : 'add'];
        if(this.isEdit) {
          data = Object.assign(this.currentRow, data);
          delete data.createTime;
          delete data.updateTime;
        }
        await request(action, data);
        this.$message.success(this.$t('操作成功'));
        this.showDialog = false;
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    handleShowFormDialog(row) {
      if(row) {
        this.currentRow = {...row};
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.showDialog = true;
    },

    async handleBatchDelete() {
      try {
        const codes = this.selection.map(i => i.code);
        if(!codes.length) {
          this.$message.warning(this.$t('请选择要删除的项'));
          return;
        }
        await requestByTip(this.$api.liquidCrystal.batchDelete, codes, {isJson: true}, {message: this.$t('您现在正在进行批量删除操作, 是否继续?')});
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.log(e);
      }
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.liquidCrystal.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async loadList(params, setTotal) {
      try {
        const res = await request(this.$api.liquidCrystal.list, params);
        this.tableData = res.liquidCrystals;
        setTotal(res.pager.itemCount);
      } catch (e) {
        console.log(e);
      }
    }
  },
  watch: {
    selection: {
      handler(list) {
        const codes = list.map(i => i.code);
        this.$emit("select", {liquidCrystalCodes: codes});
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>

</style>
